<template>
  <Layout>
    <div class="top" :style="{height: fullHeight+'px',textAlign:'center'}">
      <div :style="{marginTop: fullHeight/4+'px'}">
<!--      <p style="font-size: 30px;color: #704aff;font-family:宋体;font-weight:bold">PSD,  PNG, JPG</p>-->
      <p style="font-size: 30px;color: #535353;margin-top: 20px;font-weight: bold">精美动态壁纸</p>
      <Input search v-model="searchVal" suffix="ios-search" placeholder="搜索动态壁纸" style="width: 23%;box-shadow: 0 0 5px #888888;margin-top: 60px" @on-search="search(1)" />
      <p/>
    </div>
    </div>
    <Content style="">
      <div style="width: 85%;margin: auto; padding-top: 50px">
      <video v-for="(i,index) in imagesData" preload="metadata" @click="clickImage(i.id)" :key="i.id" muted onMouseOver="this.play()" onMouseOut="this.pause()" :src="i.url" width="300px" style="margin: 10px"></video>
      </div>
    </Content>
    <Footer style="text-align: center">
      <Page ref="pages" :total=total :page-size="30" @on-change="pageClick"/>
    </Footer>
  </Layout>
</template>

<script>
  import {ajaxFetch} from '../utils'
  export default {
    name: 'DynamicWallpaperPage',
    computed: {
      fullHeight: function () {
        // return  window.innerWidth*0.20625
        return 400
      }
    },
    data () {
      return {
        isSearch: false,
        searchVal: '',
        total: 0,
        imagesData:[],
      }
    },
    mounted: function () {
      this.listByDiscover(0)
    },
    methods: {
      listByDiscover: function (current) {
        ajaxFetch('post','/client/productTable/listByType',{type: 2, current:current, size:30},(response) => {
          if (response.code === 200) {
            this.imagesData = response.data.data
            this.total = parseInt(response.data.total)
          } else {

          }
        }, (err) => {
          console.log(err)
        } )
      },
      pageClick: function(page) {
        window.scrollTo(0,0);
        if(this.isSearch){
          this.search(page)
        }else {
          this.listByDiscover(page)
        }
      },
      clickImage: function (id) {
        this.$router.push({name: 'detailMp4Page', query: {id: id}})
      },
      search: function (current) {
        if (current === 1 ){
          this.$refs['pages'].currentPage = 1
        }
        this.isSearch = true
        ajaxFetch('post','/client/productTable/searchByName',{type: 2, name: this.searchVal, current:current, size:30},(response) => {
          if (response.code === 200) {
            this.imagesData = response.data.data
            this.total = parseInt(response.data.total)
          } else {
          }
        }, (err) => {
          console.log(err)
        } )
      },
    }
  }
</script>

<style scoped>
.top {
  background:url('../assets/first.png');
  width:100%;
  background-size: cover;
}
  li {
    display: inline;
    list-style: none;
    margin-left: 10px;
    margin-right: 10px;
    /*text-align:center;*/
  }
.addClass {
  color: #704aff;
  border-bottom: 2px solid #704aff;
}
</style>



// WEBPACK FOOTER //
// src/components/DynamicWallpaperPage.vue